import { render } from "./OwnerTable.vue?vue&type=template&id=70a662e4"
import script from "./OwnerTable.vue?vue&type=script&lang=js"
export * from "./OwnerTable.vue?vue&type=script&lang=js"

import "./OwnerTable.vue?vue&type=style&index=0&id=70a662e4&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__